<template>
  <v-app class="notfound">
    <v-container>
      <br /><br />
      <v-main align="center" justify="center">
        <div class="circles">
          <p>
            404<br />
            <small>PAGE NOT FOUND</small>
          </p>
          <span class="circle big"></span>
          <span class="circle med"></span>
          <span class="circle small"></span>
        </div>
      </v-main>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: "NotFound",
  components: {}
};
</script>

<style scoped>
@import url(https://fonts.googleapis.com/css?family=Raleway:300,700);

.circles:after {
  content: "";
  display: inline-block;
  width: 100%;
  height: 100px;
  background: #fff;
  position: absolute;
  top: -50px;
  left: 0;
  transform: skewY(-4deg);
  -webkit-transform: skewY(-4deg);
}

.circles {
  background: #fff;
  text-align: center;
  position: relative;
}

.circles p {
  font-size: 240px;
  color: #fff;
  padding-top: 60px;
  position: relative;
  z-index: 9;
  line-height: 100%;
  height: 100px;
}

.circles p small {
  font-size: 40px;
  line-height: 100%;
  vertical-align: top;
}

.circles .circle.small {
  width: 140px;
  height: 140px;
  border-radius: 50%;
  background: #48a9e6;
  position: absolute;
  z-index: 1;
  top: 0px;
  animation: 7s smallmove infinite cubic-bezier(1, 0.22, 0.71, 0.98);
  -webkit-animation: 7s smallmove infinite cubic-bezier(1, 0.22, 0.71, 0.98);
  animation-delay: 1.2s;
  -webkit-animation-delay: 1.2s;
}

.circles .circle.med {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: #48a9e6;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 10%;
  animation: 7s medmove infinite;
  -webkit-animation: 7s medmove infinite;
  animation-delay: 0.4s;
  -webkit-animation-delay: 0.4s;
}

.circles .circle.big {
  width: 400px;
  height: 400px;
  border-radius: 50%;
  background: #48a9e6;
  position: absolute;
  z-index: 1;
  top: 200px;
  right: 0;
  animation: 8s bigmove infinite;
  -webkit-animation: 8s bigmove infinite;
  animation-delay: 3s;
  -webkit-animation-delay: 1s;
}

@-webkit-keyframes smallmove {
  0% {
    top: 10px;
    left: 45%;
    opacity: 1;
  }
  25% {
    top: 200px;
    left: 40%;
    opacity: 0.7;
  }
  50% {
    top: 240px;
    left: 55%;
    opacity: 0.4;
  }
  75% {
    top: 100px;
    left: 40%;
    opacity: 0.6;
  }
  100% {
    top: 10px;
    left: 45%;
    opacity: 1;
  }
}
@keyframes smallmove {
  0% {
    top: 10px;
    left: 45%;
    opacity: 1;
  }
  25% {
    top: 200px;
    left: 40%;
    opacity: 0.7;
  }
  50% {
    top: 240px;
    left: 55%;
    opacity: 0.4;
  }
  75% {
    top: 100px;
    left: 40%;
    opacity: 0.6;
  }
  100% {
    top: 10px;
    left: 45%;
    opacity: 1;
  }
}

@-webkit-keyframes medmove {
  0% {
    top: 0px;
    left: 20%;
    opacity: 1;
  }
  25% {
    top: 200px;
    left: 30%;
    opacity: 0.7;
  }
  50% {
    top: 240px;
    left: 45%;
    opacity: 0.4;
  }
  75% {
    top: 100px;
    left: 40%;
    opacity: 0.6;
  }
  100% {
    top: 0px;
    left: 20%;
    opacity: 1;
  }
}

@keyframes medmove {
  0% {
    top: 0px;
    left: 20%;
    opacity: 1;
  }
  25% {
    top: 200px;
    left: 30%;
    opacity: 0.7;
  }
  50% {
    top: 240px;
    left: 45%;
    opacity: 0.4;
  }
  75% {
    top: 100px;
    left: 40%;
    opacity: 0.6;
  }
  100% {
    top: 0px;
    left: 20%;
    opacity: 1;
  }
}

/* SCALING */
@media (min-width: 450px), (min-height: 350px) {
  @-webkit-keyframes bigmove {
    0% {
      top: 0px;
      right: 30%;
      opacity: 0.5;
    }
    25% {
      top: 80px;
      right: 40%;
      opacity: 0.4;
    }
    50% {
      top: 120px;
      right: 35%;
      opacity: 0.8;
    }
    75% {
      top: 80px;
      right: 40%;
      opacity: 0.6;
    }
    100% {
      top: 0px;
      right: 30%;
      opacity: 0.5;
    }
  }
  @keyframes bigmove {
    0% {
      top: 0px;
      right: 25%;
      opacity: 0.5;
    }
    25% {
      top: 40px;
      right: 35%;
      opacity: 0.4;
    }
    50% {
      top: 90px;
      right: 30%;
      opacity: 0.8;
    }
    75% {
      top: 40px;
      right: 35%;
      opacity: 0.6;
    }
    100% {
      top: 0px;
      right: 25%;
      opacity: 0.5;
    }
  }
}
@media (max-width: 450px), (max-height: 350px) {
  .circles p {
    font-size: 180px;
  }
  @-webkit-keyframes bigmove {
    0% {
      top: 0px;
      right: 0%;
      opacity: 0.5;
    }
    25% {
      top: 40px;
      right: 0%;
      opacity: 0.4;
    }
    50% {
      top: 90px;
      right: 0%;
      opacity: 0.8;
    }
    75% {
      top: 40px;
      right: 0%;
      opacity: 0.6;
    }
    100% {
      top: 0px;
      right: 0%;
      opacity: 0.5;
    }
  }
  @keyframes bigmove {
    0% {
      top: 0px;
      right: 0%;
      opacity: 0.5;
    }
    25% {
      top: 40px;
      right: 0%;
      opacity: 0.4;
    }
    50% {
      top: 90px;
      right: 0%;
      opacity: 0.8;
    }
    75% {
      top: 40px;
      right: 0%;
      opacity: 0.6;
    }
    100% {
      top: 0px;
      right: 0%;
      opacity: 0.5;
    }
  }
}
@media (max-width: 280px), (max-height: 250px) {
  .circles p {
    font-size: 180px;
  }
  @-webkit-keyframes bigmove {
    0% {
      top: 0px;
      right: 0%;
      opacity: 0.5;
    }
    25% {
      top: 40px;
      right: 0%;
      opacity: 0.4;
    }
    50% {
      top: 90px;
      right: 0%;
      opacity: 0.8;
    }
    75% {
      top: 40px;
      right: 0%;
      opacity: 0.6;
    }
    100% {
      top: 0px;
      right: 0%;
      opacity: 0.5;
    }
  }
  @keyframes bigmove {
    0% {
      top: 0px;
      right: 0%;
      opacity: 0.5;
    }
    25% {
      top: 40px;
      right: 0%;
      opacity: 0.4;
    }
    50% {
      top: 90px;
      right: 0%;
      opacity: 0.8;
    }
    75% {
      top: 40px;
      right: 0%;
      opacity: 0.6;
    }
    100% {
      top: 0px;
      right: 0%;
      opacity: 0.5;
    }
  }
}
</style>
